
const Shape = require ('../class/shapes.js');

class Start {
    constructor(x,y,w,h,device,constellation,EventBus){
        this.x=x;
        this.y=y;
        this.w=w-4;
        this.h=h;
        this.padding=5;
        this.sizeText=6;
        this.nloop = 0;
        this.id=constellation.id;
        this.shape= { 
          motion: null,
          tag_motion: '',
          objects: null,
          tag_objects: ''
        };
        this.device=device;
        this.constellation=constellation;
        this.EventBus=EventBus;
        this.coordsAnalitic={};
        this.sizeFooter = 10;
        this.positionIcon = null;
        this.tag_current=[];
        this.type_shape = {
          objects : 'success',
          color_objects : 'grey',
          motion : 'normal',
          color_motion : 'grey',
        };
        let vm=this;
        let type_analityc = 'motion';
         if(EventBus) {
             let data_event = {device: this.device, constellation: this.constellation}
             this.EventBus.$emit('start_constellation_j', data_event);
             


             // Receiving Data
             this.EventBus.$on('start'+this.device.deviceId,(data)=>{    

              let tags = [];
              // ************************* Motion ***********************************
              if (vm.getInsideAnalitic(0) ) {

                if (data.channel == 'motion') {
                  if (vm.shape.motion) {
                    let is_active_objects = vm.shape.motion.getIsActive();
                    if (!is_active_objects) {
                       vm.shape.motion.setTimeShape();
                    }else{
                      delete vm.shape.motion ;

                    }

                    if (!vm.shape.motion) {               
                      vm.shape.motion = new Shape(...vm.getInsideAnalitic(0));
                      vm.shape.motion.addShappe(
                        vm.context, 
                        vm.type_shape.motion , 
                        vm.type_shape.color_motion, 
                        'motion'
                      );
                    }
                  }
                }
              }

              // ************************* Objects ***********************************
              if (vm.getInsideAnalitic(1)) {

                if (data.channel == 'objects' ) {
                  // console.log(data, 'info')          
                  if (data.analytics_results && data.analytics_results.length > 0 ) {
                    tags= data.analytics_results;
                     
                    if (tags && tags.length > 0) {

                      let tag_temp = '';
                      tags.forEach( function(arr_tag, idx_tag){
                        if (vm.shape.objects ) {
                          let is_active_objects = vm.shape.objects.getIsActive();
                          if (is_active_objects && tag_temp == arr_tag.tag) {
                            
                            vm.shape.objects.setTimeShape();

                          }else{
                            delete vm.shape.objects ;
                          }
                        }
                        if (!vm.shape.objects) {                      
                          vm.shape.objects = new Shape(...vm.getInsideAnalitic(1)); 

                          vm.shape.objects.addShappe(
                            vm.context, 
                            vm.type_shape.objects, 
                            vm.type_shape.color_objects, 
                            arr_tag.tag
                          );
                        }            
                        tag_temp = arr_tag.tag;
                        
                      })
                    }
                  }
                }
              }

                //vm.drawShape()
             });

             // Receiving status
             this.EventBus.$on('status_analytic' + this.device.deviceId, (stats) =>{
              let stateCam      = false,
                  stateAnalytic = false,
                  stateAnalyticMotion = false;
                if (stats) {
                  if (stats.motion) {
                    if (stats.motion.statusCam !== stateCam) {                      
                      let is_active = 'active';
                      stateCam = stats.motion.statusCam;
                      if (!stateCam){
                        is_active = 'inactive';
                      }
                      
                      this.setStatusDevice(is_active);
                    }

                    if (stats.motion.statusAnalytics !== stateAnalyticMotion) {                      
                      let is_active = 'active';
                      stateAnalyticMotion = stats.motion.statusCam;
                      if (!stateAnalyticMotion){
                        is_active = 'inactive';
                      }
                      this.setStatusAnalytic(is_active, 0);
                    }
                  }
                 
                  if (stats.object && stats.object.statusAnalytics !== stateAnalytic) {
                    let is_active = 'active';
                    stateAnalytic = stats.object.statusAnalytics;
                    
                    if (!stateAnalytic) {
                      is_active = 'inactive'
                    }
                    
                    this.setStatusAnalytic(is_active, 1);

                  }
                }
             })
         }

    }
    setEventBus1(eventbus){
        this.EventBus=eventbus;
        let vm=this;

        if(this.EventBus){
            let data_event={device:this.device,constellation:this.constellation}
            this.EventBus.$emit('start_constellation_j',data_event);

           this.EventBus.$on('start'+this.device[0].deviceId,(data)=>{

               // console.log(...vm.getInsideStart(),"tyestjca")


                //this.shape = new Shape(...this.getInsideStart());
                //this.shape.addShappe(this.context, 'normal');
                //vm.drawShape()
            })
        }

    }
    getDraw(){
        return {
            x: this.x,
            y: this.y,
            w: this.w,
            h: this.h
        };
    }

   /* drawPoint(x,y,w,h){
        console.log('drawPoint')
        this.x =x;
        this.y =y;
        this.w =w;
        this.h =h;
    }*/
    drawShape(){

        if(this.context){

          this.context.beginPath();
         
          let grad = this.context.createLinearGradient(0,200,200,0);
          grad.addColorStop(0, 'rgba(192,192,192,1)');
          grad.addColorStop(0.5, 'rgba(255,255,255,1)');
          grad.addColorStop(1, 'rgba(128,128,128,1)');
                            
          this.context.fillStyle = grad;
          this.context.fillRect(...this.getInsideStart());          
         
          this.remove(2);
          
          

        }else{
            console.log("Context  of  canvas  is  null")
        }
    }
    remove(n){
        let vm = this;

        if(this.nloop < n){
          const timer_loop = setTimeout(function () {
            vm.context.clearRect(...vm.getInsideStart());
              const timer_draw = setTimeout(function () {
                  vm.nloop++;
                vm.drawShape(null)
                clearTimeout(timer_draw);
              },700)
            clearTimeout(timer_loop)
          },1000)


        }else{
          this.context.clearRect(...vm.getInsideStart());
          this.context.fillStyle = "black";  
          this.context.strokeRect(...(Object.values(this.getDraw())));
          this.setInsideAnalitic(4);
          
          //vm.drawShape(null);
        }

    }
    getInsideStart() {
        let coords = this.getDraw();
        //return [coords.x + this.padding, coords.y + this.padding + this.paddingText, coords.w - (this.padding + this.padding), coords.h - (this.padding + this.paddingText)];
        return [
          coords.x + this.padding, 
          coords.y + this.padding + this.sizeText, 
          coords.w - this.padding, 
          coords.h - this.padding - this.sizeText];
    }

    getcoordsTitle(){
      let coords = this.getInsideStart();
      return [coords[0], coords[1] - this.padding-this.sizeText, coords[2] , 10]
      //let coords = this.getDraw();
      //return [ coords.x + this.padding, coords.y + this.padding , coords.w - this.padding , this.paddingText ];
    }
  
    setInsideAnalitic(num = 4){
      let coords = this.getInsideStart();
      // this.coordsAnalitic;
      let n = num,
          grad,
          r,
          decimal,
          nm = 0;
      let w = coords[2],
          h = coords[3];
      r = Math.sqrt(n);       
        
      decimal = (r+"").split(".")[1];
      nm    = (r+"").split(".")[0]
      
      if ( decimal > 0 ) {
        nm ++; 
      }

      let bx = coords[0], // pos X
          by = coords[1], // pos Y
          bw = 0, // width
          bh = 0, // height
          file = 0, 
          column = 0,
          sw = w / nm,
          sh = h / nm;

      bw = sw;
      bh = sh;

      // console.log(n , 'N elementos    W :', w, ' H : ', h)
      let  control_device=0;
      while (file < nm){
        while (column < nm){
          this.context.beginPath();          
          // this.context.strokeRect(bx, by, bw , bh - this.sizeFooter);
          this.coordsAnalitic[control_device] = { 
            x: bx, 
            y: by, 
            w: bw, 
            h: bh - this.sizeFooter
          };
          this.setStatusAnalytic('inactive', control_device);
          bx = bx + sw;
          column++;
          control_device++; 
        
        } //  while column
        
        bx    = coords[0];
        by    = by + bh; 
        column  = 0;
        file++;

      } // while f

    }

    getInsideAnalitic(n){
      let coords = this.coordsAnalitic[n];
      // console.log(coords, n, 'analitic')
      if (coords && coords.x & coords.y && coords.w && coords.w && coords.h ) {

        return [coords.x + this.padding, coords.y + this.padding, coords.w - this.padding, coords.h - this.padding]
      }else{
        return false
      }

    }

    setStatusDevice(is_status = 'inactive'){
      let  status = new Shape(
        (this.x + this.w) - ((this.padding * 2) + this.sizeText ), 
        this.y , 
        this.sizeText + (this.padding * 2),
        (this.padding * 2) + this.sizeText 
        );        


      // set color
      let color = 'green';
      
      if (is_status == 'inactive') {
        color = 'red';
      }
      
      // draw
      status.addShappe(this.context, 'success', color, '', true);
    }

    setCamStream(){
      let img = new Image();
      let vn = this;
      img.src = '/img/video_icon.png';
      console.log('setcam')
      img.onload = function(){
        vn.context.drawImage(img,  
          (vn.x + vn.w) - ((vn.padding * 4) + (vn.sizeText * 2) ), 
          vn.y , 
          vn.sizeText + (vn.padding),
          (vn.padding) + vn.sizeText )
      }
      this.positionIcon = {
        x :(vn.x + vn.w) - ((vn.padding * 4) + (vn.sizeText * 2) ), 
        y :  vn.y , 
        w : vn.sizeText + (vn.padding),
        h : (vn.padding) + vn.sizeText 
      }
    }

    setStatusAnalytic(is_status='inactive', n){
      let coords = this.coordsAnalitic[n];
      let text   = '';
      let color = 'green';
      

      // set color 
      if (is_status == 'inactive') {
        color = 'red';
      }

     // set subtitle
      if (n == 0) {
        text = 'motion';
      }

      if (n == 1 ) {
        text = 'objects';
      }


      let vn = this;      
      if (coords) {        
                
          this.context.beginPath();
          // this.context.fillStyle = 'green'

          /*this.context.strokeRect(
              coords.x,
              coords.y + coords.h,
              coords.w,
              vn.sizeFooter  

          )*/

          // set status shape circle
          let analitic = new Shape(
            coords.x,
            coords.y + coords.h + vn.padding,
            vn.sizeText + (vn.padding * 2),
            vn.sizeFooter - vn.padding
          );

          // analitic.addShappe(this.context, 'success', color, '', true);

          /*if (text !== '') {
            console.log('text analitic')
            this.context.beginPath();
            this.context.font = "10px Georgia";
            this.context.fillStyle = "white"//"rgba(255,255,255, 0.9)";
            this.context.fillText(
              text, 
              coords.x + vn.sizeFooter + vn.padding,
              coords.y + coords.h + vn.padding + 2 ,
              coords.w
            );
          }*/
      }

    }

    drawToCanvas(context){
      this.context =  context;

      // rect title
      this.context.beginPath();
      this.context.fillStyle = "black";            
      this.context.fillRect(...this.getcoordsTitle());
      // this.context.stroke();
        
      // for scale
      // window.devicePixelRatio=1;
      // let scale = window.devicePixelRatio;
      
      // Add title
      this.context.beginPath();              
      // this.context.scale(scale, scale);
      this.context.font       = "10px Georgia";
      this.context.fillStyle  = "rgba(255,255,255, 0.9)";
      if (this.device) {
        this.context.fillText(
          this.device.name, 
          this.x  + this.padding + this.sizeText, 
          this.y  + this.padding + this.sizeText - 3, 
          this.w
        );
      }

      this.setStatusDevice();
      this.setCamStream(); 

      this.drawShape(null)
    }

    setShape(shape, color, type_analytic){
      console.log('change shape')
      this.type_shape[type_analytic]            = shape;
      this.type_shape['color_' + type_analytic] = color;
    }

    resize(x,y,w,h){
      this.x=x;
      this.y=y;
      this.w=w;
      this.h=h;
    }
}

module.exports = Start;